import { useState } from "react";
import ApiFetch from "../../services/api.fetch";
import { URLS } from "../../utils/url";

export const useUnsubscribeFromProperty = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    message: "",
    status: false,
  });

  const unsubscribeFromProperty = async (
    userId: number,
    propertyId: number,
    allCollections: boolean
  ) => {
    if (!userId || !propertyId) {
      setError({ message: "Missing parameters", status: true });
      return;
    }

    try {
      setLoading(true);
      await ApiFetch.httpGet(
        URLS.get.tenant.unsubscribeFromProperty.params(
          userId,
          propertyId,
          allCollections
        )
      );
    } catch (error) {
      setError({
        message: "Something went wrong",
        status: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    unsubscribeFromProperty,
  };
};
